import React, { useContext, useEffect, useState } from 'react';
import './Copilot.css';
import $ from 'jquery';
import { getCurrentUserMentors, isJSON } from './helpers/utils';
import { useDebounce } from './helpers/useDebounce';
import chatbotCollapseIcon from './assets/images/ibl-gpt-ai.gif';
import { getTenant, handleLogout } from '../../hooks';
import { AppDataContext } from '../../utils';
import '@acilearning/iblai-web-mentor';

const Copilot = ({
  isWhiteThemed = true,
  backgroundColor = '',
  theme = 'light',
}) => {
  const { appData, setAppData } = useContext(AppDataContext);
  const MIN_RESIZE_POINT = 0;
  const MAX_RESIZE_POINT = 1170;
  const [iframeHTML] = useState(null);
  const [mentorSidebarVisible, setMentorSidebarVisible] = useState(false);
  const [mentorInUse, setMentorInUse] = useState('');
  const [hasReachedResizeMaxPoint, setHasReachedResizeMaxPoint] = useState(
    window.innerWidth <= MAX_RESIZE_POINT &&
    window.innerWidth >= MIN_RESIZE_POINT
  );
  const [mentorIsCollapsed, setMentorIsCollapsed] = useState(
    window.innerWidth <= MAX_RESIZE_POINT &&
    window.innerWidth >= MIN_RESIZE_POINT
  );

  const modalLoaderColorProps = isWhiteThemed
    ? {
      displayTextColor: '#888',
      backgroundColor: '#FFF',
    }
    : {
      displayTextColor: '#FFF',
      backgroundColor: '#000',
      loaderColor: '#FFF',
    };

  const handleLoadCoPilot = async () => {
    //setLoading(true)
    getCurrentUserMentors((mentors) => {
      //setLoading(false)
      const generatedMentors = mentors?.results;
      if (!(Array.isArray(generatedMentors) && generatedMentors.length > 0)) {
        setMentorSidebarVisible(false);
        return;
      }
      setMentorInUse(
        (
          generatedMentors?.find((item) => item?.metadata?.default) ||
          generatedMentors[0]
        )?.slug
      );
      setMentorSidebarVisible(true);
      setAppData({
        ...appData,
        sidebarCopilotTriggered: true,
      });
    });
  };

  const handleIframeLoad = () => {
    const widgetContainer = document.getElementById('mentor-placeholder');
    //const IBL_MENTOR_WIDGET_ORIGIN = 'https://mentor.iblai.tech';
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    const iframeURLQueryParams = new URLSearchParams({
      'show-profile': 'false',
      embed: 'true',
      mode: 'anonymous',
      'extra-body-classes': 'iframed-externally',
    }).toString();
    iframe.src = encodeURI(
      `${process.env.REACT_APP_IBL_MENTOR_IFRAME_WIDGET_ORIGIN_URL
      }/platform/${getTenant()}/${mentorInUse}?${iframeURLQueryParams}`
    );
    //mentor.iblai.app/platform/main/ai-mentor?embed=true&mode=anonymous&extra-body-classes=iframed-externally
    https: iframe.style.border = '0px white';
    iframe.style.height = '100%';
    iframe.style.width = '100%';

    iframe.id = 'iframed-mentor';
    iframe.setAttribute('allow', 'microphone; clipboard-read; clipboard-write');
    //iframe.onload = ()=>pushTokenToMentor(isWhiteThemed);
    //const slug = getPageSlug();
    const additionalStyles = {
      globalFontFamily: $('body').css('font-family'),
      globalFontColor: isWhiteThemed // !slug.includes('admin')
        ? $('body').css('color')
        : 'inherit',
    };
    const cssStyle = `
      body{
        font-family:${additionalStyles.globalFontFamily};
        color:${additionalStyles.globalFontColor};
        overflow: hidden!important;
      }
      ${!!backgroundColor
        ? `
        body.body.dark-mode {
          background-color: ${backgroundColor}!important;
        }
      `
        : ''
      }
      
      .user-pic-container, .logo-container{
        display:none;
      }
      .default-featured-mentor-label-block{
        display:flex;
      }
      .ai-expert-header-btn-container{
        align-items: center;
      }
      .default-featured-mentor-label-block{
        display:flex;
      }
      .ai-expert-choose-label{
        display:block;
        white-space:pre!important;
      }
    `;
    const iframeInjectData = {
      css: cssStyle,
      ...(!isWhiteThemed
        ? {
          theme: 'dark',
        }
        : {}),
      ...localStorage,
    };
    const iframeInJectMessage = JSON.stringify(iframeInjectData);
    // widgetContainer?.appendChild(iframe);
    if (window.innerWidth > 480) {
      $('.full').addClass('w-bar');
    }
    // window.addEventListener('message', function (event) {
    //   if (event && isJSON(event?.data)) {
    //     const msg = JSON.parse(event.data);
    //     if (msg?.closeEmbed) {
    //       setHasReachedResizeMaxPoint(true);
    //       setMentorIsCollapsed(true);

    //       return;
    //     }
    //     const mentorLocalstorage = msg?.auth;
    //     const axdToken = localStorage.getItem('axd_token');
    //     if (msg?.loaded && mentorLocalstorage?.axd_token !== axdToken) {
    //       //axd tokens don't match
    //       iframe?.contentWindow?.postMessage(iframeInJectMessage, '*');
    //     }
    //     if (msg?.authExpired) {
    //       //trigger logout of the current SPA when axd token expired
    //       if (mentorLocalstorage?.axd_token === axdToken) {
    //         handleLogout(window.location.href);
    //       } else {
    //         iframe?.contentWindow?.postMessage(iframeInJectMessage, '*');
    //       }
    //     }
    //   }
    // });
  };

  useEffect(() => {
    handleLoadCoPilot();
  }, []);

  const handleReachResizeMaxPoint = () => {
    if (
      window.innerWidth <= MAX_RESIZE_POINT &&
      window.innerWidth >= MIN_RESIZE_POINT
    ) {
      setHasReachedResizeMaxPoint(true);
      setMentorIsCollapsed(true);
    } else {
      setHasReachedResizeMaxPoint(false);
      setMentorIsCollapsed(false);
    }
  };

  const handleUnCollapseMentor = () => {
    const iframedSite: HTMLIFrameElement =
      document.querySelector('#iframed-mentor');
    const message = JSON.stringify({
      enableCloseButton: true,
    });
    const copilotContainer = document.querySelector<HTMLElement>(
      '.right-content.copilot-full-container'
    );
    if (copilotContainer) {
      // copilotContainer.style.setProperty('width', '380px', 'important');
      copilotContainer.classList.remove('resize-max-point-reached');
    }
    const collapseBlock = document.querySelector<HTMLElement>(
      '.right-content .chatbot-collapse-block'
    );
    if (collapseBlock) {
      collapseBlock.style.setProperty('display', 'none', 'important');
    }
    const chatbot = document.querySelector<HTMLElement>(
      '.right-content > .chat-box.logged-in.hidden'
    );
    if (chatbot) {
      chatbot.classList.remove('collapsed');
    }
    iframedSite?.contentWindow?.postMessage(message, '*');
  };

  const handleIframedSidebarClose = (event) => {
    if (!!event && !!isJSON(event?.data)) {
      const msg = JSON.parse(event.data);
      if (!!msg?.collapseSidebarCopilot) {
        const copilotContainer = document.querySelector<HTMLElement>(
          '.right-content.copilot-full-container'
        );
        if (copilotContainer) {
          // copilotContainer.style.setProperty('width', '60px', 'important');
          copilotContainer.classList.add('resize-max-point-reached');
        }
        const collapseBlock = document.querySelector<HTMLElement>(
          '.right-content .chatbot-collapse-block'
        );
        if (collapseBlock) {
          collapseBlock.style.setProperty('display', 'flex', 'important');
        }
        const chatbot = document.querySelector<HTMLElement>(
          '.right-content > .chat-box.logged-in.hidden'
        );
        if (chatbot) {
          // chatbot.style.setProperty('display', 'none', 'important');
          // chatbot.style.setProperty('width', 'auto', 'important');
          chatbot.classList.add('collapsed');
        }
        setMentorIsCollapsed(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleReachResizeMaxPoint);
    return () => {
      window.removeEventListener('resize', handleReachResizeMaxPoint);
    };
  }, []);

  useEffect(() => {
    window.addEventListener('message', handleIframedSidebarClose);
    return () => {
      window.removeEventListener('message', handleIframedSidebarClose);
    };
  }, []);

  useDebounce(
    () => {
      if (mentorSidebarVisible) {
        handleIframeLoad();
      }
    },
    150,
    [mentorSidebarVisible]
  );

  useDebounce(
    () => {
      /* TARGETTING SIBLING ELEMENT TO COPILOT (LEFT HAND SIDE AREA) */
      if (mentorIsCollapsed) {
        $('.right-content.copilot-full-container')
          .prev()
          .css({ paddingRight: '60px' });
        $('.right-content.copilot-full-container').addClass(
          'resize-max-point-reached'
        );
      } else {
        $('.right-content.copilot-full-container')
          .prev()
          .css({ paddingRight: '380px' });
        const copilotContainer = document.querySelector<HTMLElement>(
          '.right-content.copilot-full-container'
        );
        if (copilotContainer) {
          // copilotContainer.style.setProperty('width', '380px', 'important');
        }
        const collapseBlock = document.querySelector<HTMLElement>(
          '.right-content .chatbot-collapse-block'
        );
        if (collapseBlock) {
          collapseBlock.style.setProperty('display', 'none', 'important');
        }
        const chatbot = document.querySelector<HTMLElement>(
          '.right-content > .chat-box.logged-in.hidden'
        );
        // if (chatbot) {
        //   chatbot.style.setProperty('display', 'flex', 'important');
        //   chatbot.style.setProperty('width', 'auto', 'important');
        // }
        //DONT SHOW CLOSE BUTTON ON SIDEBAR IFRAME MENTOR
        const iframedSite: HTMLIFrameElement =
          document.querySelector('#iframed-mentor');
        const message = JSON.stringify({
          enableCloseButton: false,
        });
        iframedSite?.contentWindow?.postMessage(message, '*');
      }
    },
    100,
    [mentorIsCollapsed]
  );

  //useDebounce(handleLoadCoPilot, 200, []);

  return (
    <>
      {mentorSidebarVisible ? (
        <div
          className={`right-content copilot-full-container ${hasReachedResizeMaxPoint ? 'resize-max-point-reached' : ''
            }`}
        >
          {mentorIsCollapsed && (
            <div
              onClick={() => {
                setMentorIsCollapsed(false);
                handleUnCollapseMentor();
              }}
              className={`chatbot-collapse-block`}
            >
              <img
                src={chatbotCollapseIcon}
                className={`chatbot-collapsed-icon`}
              />
            </div>
          )}
          <div
            className={`chat-box logged-in hidden ${mentorIsCollapsed ? 'collapsed' : ''
              }`}
          >
            <div className="div-block-549">
              <div
                className="html-embed-15 w-embed w-iframe"
                id="mentor-placeholder"
              >
                <mentor-ai
                  mentorUrl={
                    process.env.REACT_APP_IBL_MENTOR_IFRAME_WIDGET_ORIGIN_URL
                  }
                  authUrl={process.env.REACT_APP_IBL_SPA_AUTH_URL}
                  lmsUrl={process.env.REACT_APP_IBL_LMS_URL}
                  tenant={getTenant()}
                  mentor={mentorInUse}
                  contextOrigins={`${process.env.REACT_APP_IBL_LMS_URL}`}
                  authRelyOnHost
                  isContextAware
                  theme={theme}
                  {...(process.env.REACT_APP_IBL_MENTOR_CHAT_ADVANCE && {
                    isAdvanced: true,
                  })}
                ></mentor-ai>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export { Copilot };
